/**
 * Scroll Into Bounds
 * Takes a instance of a element that is a scroll frame and a target element.
 * If the target is partly or entirely outside the bounds of the scroll frame
 * it is scrolled to the center. This works for both vertical and horizontal scrolling.
 * @param  {HTMLElement|any} scrollFrameElement
 * @param  {HTMLElement|any} targetElement
 * @returns void
 */

function scrollIntoBounds(scrollFrameElement, targetElement) {
  // Guard against running the outside of a browser window
  if (typeof window === 'undefined' || !(scrollFrameElement instanceof HTMLElement) || !(targetElement instanceof HTMLElement)) {
    return;
  }
  const {
    top: scrollFrameTop,
    right: scrollFrameRight,
    bottom: scrollFrameBottom,
    left: scrollFrameLeft
  } = scrollFrameElement.getBoundingClientRect();
  const {
    top: targetTop,
    right: targetRight,
    bottom: targetBottom,
    left: targetLeft
  } = targetElement.getBoundingClientRect();
  if (targetRight > scrollFrameRight || targetLeft < scrollFrameLeft) {
    // eslint-disable-next-line no-param-reassign
    scrollFrameElement.scrollLeft -= diffCenters(scrollFrameLeft, scrollFrameRight, targetLeft, targetRight);
  }
  if (targetBottom > scrollFrameBottom || targetTop < scrollFrameTop) {
    // eslint-disable-next-line no-param-reassign
    scrollFrameElement.scrollTop -= diffCenters(scrollFrameBottom, scrollFrameTop, targetBottom, targetTop);
  }
}

/* Find the difference in the center points between two 1D line segments */
function diffCenters(frameMin, frameMax, targetMin, targetMax) {
  const scrollFrameCenter = (frameMax - frameMin) / 2 + frameMin;
  const targetCenter = (targetMax - targetMin) / 2 + targetMin;
  return scrollFrameCenter - targetCenter;
}

export { scrollIntoBounds as s };
//# sourceMappingURL=scrollIntoBounds-Dhl2O567.js.map
